module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "شكر-وتقدير"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شكر وتقدير")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كل الشكر والتقدير للمدرِّسين في مراحل التعليم الأساسي، وللأُسرَة الكريمَة، ولكلِّ مَن ساهَمَ في نَشرِ هذا الكِتاب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 72
// module chunks = 0